import { pageLinkStyle, activePageStyle, getPageNumbers } from './helpers';

const Pagination = ({ pagination, onPageChange }) => {
  const { currentPage, pageCount, prev, next } = pagination;

  if (pageCount <= 1) return null;

  const pages = getPageNumbers(currentPage, pageCount);

  return (
    <nav aria-label="Pagination">
      <ul className="pagination justify-content-center mt-4 mb-0">
        <li className={`page-item ${!prev ? 'disabled' : ''}`}>
          <button
            disabled={!prev}
            style={pageLinkStyle}
            className="page-link"
            onClick={() => onPageChange(prev)}
          >
            Previous
          </button>
        </li>

        {pages.map((page, i) =>
          page === '...' ? (
            <li key={`ellipsis-${i}`} className="page-item disabled">
              <span className="page-link">&hellip;</span>
            </li>
          ) : (
            <li key={page} className="page-item">
              <button
                className="page-link"
                disabled={page === currentPage}
                onClick={() => onPageChange(page)}
                style={page === currentPage ? activePageStyle : pageLinkStyle}
              >
                {page}
              </button>
            </li>
          )
        )}

        <li className={`page-item ${!next ? 'disabled' : ''}`}>
          <button
            disabled={!next}
            style={pageLinkStyle}
            className="page-link"
            onClick={() => onPageChange(next)}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
